/* eslint-disable complexity */
import React, { Component } from "react";
import PropTypes from "prop-types";
import style from "./styles";
import {
  IconStar,
  IconPhone,
  Popover,
  IconComment,
  rdcUiTheme,
  Type,
  Button,
  useMediaQuery,
  getQuery,
} from "@rdc-npm/rdc-ui";
import config from "lib/config";
import { SELECT_TYPE } from "util/constant";
import { getProfileUrl } from "util/createProfileIdPath";
import { PAGE_TRACKING, OMNITURE_LINK_NAME } from "static/staticData/omniture/trackingConstants";
const agentEmpty = `${config.CDN_PREFIX}/static/assets/images/Empty_AgentPhoto.svg`;
import { getAgentPhoneNumber, getaAgenthref } from "util/agentdetailsUtil";
import { encrypt } from "util/common";
// import { removeHttpImageUrl } from "util/photo";
// import { insertInImgUrl } from "util/number";
import { getContactAgentModalProperties } from "static/staticData/omniture/adp";
import {
  trackOmnitureModalImpression,
  trackOmnitureClicks,
} from "static/staticData/omniture/omnitureUtils";

const SendMessageButton = (props) => {
  const isDesktop = useMediaQuery(getQuery({ min: "md" }));

  const btnClick = () => {
    const properties = getContactAgentModalProperties(PAGE_TRACKING.ADP_PAGE.PAGE_NAME_NON_NAR);
    if (properties) {
      trackOmnitureModalImpression(properties);
    }
    props.ask_a_question_modal(props);
  };
  return (
    <>
      <style jsx>{style}</style>
      {isDesktop && (
        <div className="send-message">
          <Button styleType="PrimaryDefault" size="sm" onClick={btnClick}>
            Send message
          </Button>
        </div>
      )}
    </>
  );
};
SendMessageButton.propTypes = {
  ask_a_question_modal: PropTypes.func,
};

export default class ProfilePicSection extends Component {
  state = {
    showMoreArea: false,
    showMoretype: null,
    continueReadingStatus: true,
    servedAreaModified: null,
    specializationsModified: null,
    showDotRealtorRedirectLink: false,
    requestBody: {
      advertiser_id: "",
      tracking_token: "realtors:leads:showcase:ask-a-question",
      address: null,
      city: null,
      adv_email: null,
      adv_name: null,
      url: null,
      number: null,
      number_type: null,
      abbreviation: null,
      member_id: null,
      state: null,
      web_url: null,
      photo: null,
      zip: null,
      variant: "far_dp",
      page_name: "ldp",
      lead_type: "call",
      type: null,
      name: null,
      email: null,
      comment: null,
      is_lead_generated: true,
      referral: null,
      referral_asset: null,
      id: null,
      profileId: "",
    },
  };

  continueReadingHandler = () => {
    this.setState({
      continueReadingStatus: !this.state.continueReadingStatus,
    });
  };
  handleDotRealtorRedirectClose = () => {
    this.setState({ showDotRealtorRedirectLink: false });
  };

  sortByName = (data) => {
    data && data.sort((a, b) => a.name.localeCompare(b.name));
    return data;
  };
  updateShowMoreData = (data, type) => {
    const showDiv = true;
    const setInitialState =
      data &&
      data.map((m) => {
        m.showDiv = showDiv;
        return m;
      });
    if (type === "served_areas") {
      this.setState({
        servedAreaModified: setInitialState,
        showMoreArea: true,
        showMoretype: type,
      });
    } else if (type === "specializations") {
      this.setState({
        specializationsModified: setInitialState,
        showMoreArea: true,
        showMoretype: type,
      });
    }
  };
  updateLessData = (data, type) => {
    const showDiv = false;
    const servedAreaInitialState =
      data &&
      data.map((m, i) => {
        if (i > 19) {
          m.showDiv = showDiv;
        }
        return m;
      });

    if (type === "served_areas") {
      this.setState({
        servedAreaModified: servedAreaInitialState,
        showMoreArea: false,
        showMoretype: type,
      });
    } else if (type === "specializations") {
      this.setState({
        specializationsModified: servedAreaInitialState,
        showMoreArea: false,
        showMoretype: type,
      });
    }
  };
  handleShowMoreClick = (data, type) => {
    this.updateShowMoreData(data, type);
  };
  handleLessMoreClick = (data, type) => {
    this.updateLessData(data, type);
  };
  extractLicenseNumber = (mlsArray) => {
    let license_number;
    let primaryListing = mlsArray.find(
      (mls) => mls.primary && mls.license_number && mls.license_number !== "",
    );
    license_number = primaryListing ? primaryListing.license_number : "";
    if (!license_number) {
      let found = mlsArray.find((mls) => mls.license_number && mls.license_number !== "");
      license_number = found ? found.license_number : "";
    }
    return license_number ? "#" + license_number : "";
  };

  componentDidMount() {
    const { agentdetail } = this.props;

    let served_areas = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.served_areas;
    served_areas = this.sortByName(served_areas);
    let specializations =
      agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.specializations;
    specializations = this.sortByName(specializations);

    const showDiv = true;
    const servedAreaInitialState =
      served_areas &&
      served_areas.map((m, i) => {
        if (i < 20) {
          m.showDiv = showDiv;
        }
        return m;
      });

    const specializationsInitialState =
      specializations &&
      specializations.map((m, i) => {
        if (i < 20) {
          m.showDiv = showDiv;
        }
        return m;
      });

    this.setState({
      servedAreaModified: servedAreaInitialState,
      specializationsModified: specializationsInitialState,
    });
    if (window.location.hash && window.location.hash == "#/login") {
      // Fragment exists
      this.showReviewModal();
    } else {
      // Fragment doesn't exist
    }
  }
  trackOmnitureClick(e) {
    trackOmnitureClicks(e.currentTarget.getAttribute("data-linkname"));
  }
  showRecommendationModal = () => {
    trackOmnitureClicks(OMNITURE_LINK_NAME.ADP.WRITE_FIRST_RECOM);
    if (this.props.showRecommendationModal) {
      this.props.showRecommendationModal();
    }
  };
  showReviewModal = () => {
    trackOmnitureClicks(OMNITURE_LINK_NAME.ADP.WRITE_FIRST_REVIEW);
    const { agent_bio } = this.props?.agentdetail;
    const isLogin = this.props?.isUserLoggedIn;
    const loginData = this.props && this.props.loginData;
    const isDotRealtor =
      this.props?.query &&
      this.props?.query.isDotRealtor &&
      JSON.parse(this.props?.query.isDotRealtor)
        ? true
        : false;
    if (isDotRealtor) {
      this.setState({ showDotRealtorRedirectLink: true });
    } else {
      this.setState({ isLogin });
      if (isLogin && loginData) {
        if (this.props && this.props.showReviewModal) {
          this.props.showReviewModal(agent_bio);
        }
      } else {
        window.scrollTo(0, 0);
        this.openLoginModal();
      }
    }
  };

  openLoginModal = async () => {
    if (await document.querySelector('a[aria-label="Log into your account, opens a dialog"]')) {
      document.querySelector('a[aria-label="Log into your account, opens a dialog"]').click();
    }
  };
  submitRequest = (agentdetail, e) => {
    e.stopPropagation();
    const query = this.props && this.props.query;

    const agentProps = agentdetail && agentdetail.agent_bio;
    const advertiser_id = agentProps && agentProps.advertiser_id;
    const address = agentProps && agentProps.address;
    const person_name = agentProps && agentProps.person_name;
    const web_url = agentProps && agentProps.web_url;
    const phones = agentProps && agentProps.phones;
    const href = agentProps && agentProps.href;
    const types = agentProps && agentProps.types;
    const cid = query && query.cid;
    const lex_id = query && query.lex_id;
    const profileId = agentProps && agentProps.id;
    let photo = agentProps && agentProps.photo && agentProps.photo.href;
    photo = photo.split("http:");
    photo = photo[1];
    let requestBody = this.state.requestBody;
    requestBody.advertiser_id = advertiser_id;
    requestBody.referral = cid;
    requestBody.referral_asset = lex_id;
    const city = (address && address.city) || null;
    const stateCode = (address && address.state_code) || null;
    requestBody.city = city;
    requestBody.address = city && stateCode ? `${city}, ${stateCode}` : null;
    requestBody.adv_name = person_name || null;
    requestBody.url = web_url || null;
    requestBody.web_url = href || null;
    requestBody.photo = photo || null;
    requestBody.zip = (address && address.postal_code) || null;
    requestBody.state = stateCode;
    requestBody.type = types || null;
    requestBody.profileId = profileId;
    requestBody.is_monetized = false;
    if (phones && phones.length) {
      requestBody.number = phones[0].number ? encrypt(phones[0].number) : null;
      requestBody.number_type = phones[0].type;
    }
    if (this.props.askAQuestion) {
      this.props.askAQuestion(this.state.requestBody);
    }
  };

  render() {
    const {
      agentdetail,
      recommendationData,
      reviewData,
      lang,
      clickDetectorAndScroll,
      query,
    } = this.props;
    const { settings, agent_rating, id } = agentdetail?.agent_bio || {};
    const canShowRating = settings && settings.display_ratings;
    const personName = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.person_name;

    // const dotRealtorWebUrl = web_url;
    const dotRealtorWebUrl = getProfileUrl(id, SELECT_TYPE.AGENT, false, true);

    const imageProperties = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.photo;
    let imgurl = imageProperties && imageProperties.href;
    // imgurl = imgurl && removeHttpImageUrl(imgurl);
    // imgurl = imgurl && imgurl.replace("d-r1", "");
    // const zoomValue =
    //   imageProperties && imageProperties.is_zoomed === false ? "d-w260_h260_q50" : "d-r7_w144";
    // let profileUrl = imgurl
    //   ? /avatar.svg/.test(imgurl)
    //     ? insertInImgUrl(imgurl)
    //     : insertInImgUrl(imgurl, zoomValue, 4)
    //   : agentEmpty;
    let profileUrl = imgurl
      ? getaAgenthref("agent", agentdetail.agent_bio, agentEmpty)
      : agentEmpty;
    const isDefaultOrEmpty =
      profileUrl.includes("agent_default.png") || profileUrl.includes("Empty_AgentPhoto.svg")
        ? true
        : false;
    const officenumber = agentdetail && getAgentPhoneNumber(agentdetail);
    const callhref = "tel:" + officenumber;

    const officeName =
      agentdetail &&
      agentdetail.agent_bio &&
      agentdetail.agent_bio.office &&
      agentdetail.agent_bio.office.name;

    const fullName = agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.full_name;

    const advertiser_id =
      agentdetail && agentdetail.agent_bio && agentdetail.agent_bio.advertiser_id;
    let license_number;
    if (
      agentdetail &&
      agentdetail.agent_bio &&
      agentdetail.agent_bio.mls &&
      agentdetail.agent_bio.mls.length > 0
    ) {
      license_number = this.extractLicenseNumber(agentdetail.agent_bio.mls);
    }

    const customWidths = {
      xs: "100%",
      sm: "520px",
      md: "auto",
      lg: "auto",
    };
    const isDotRealtor =
      query && query.isDotRealtor && JSON.parse(query.isDotRealtor) ? true : false;
    return (
      <>
        <style jsx>{style}</style>

        <link content={profileUrl} />
        <div className="profile-details">
          <div>
            {agentdetail && (
              <img
                className="profile-img"
                src={profileUrl}
                alt={!isDefaultOrEmpty ? `Photo of ${fullName || personName || ""}` : ""}
              />
            )}
          </div>
          <div className="profile-info">
            {advertiser_id ? (
              <ul className="profile-mobile-icon">
                {officenumber ? (
                  <a
                    className="track-my-clicks"
                    data-linkname="realtors:_details:top:phone_number"
                    href={callhref}
                    aria-label="agent mobile number"
                    onClick={(e) => this.submitRequest(agentdetail, e)}>
                    <IconPhone color="#6c757d" size={3}></IconPhone>
                  </a>
                ) : null}
              </ul>
            ) : null}
            {advertiser_id && agentdetail && agentdetail.team && (
              <div className="badge">(Team)</div>
            )}
            {agentdetail && <Type styleType="display600"> {personName}</Type>}
            {license_number && agentdetail && (
              <Type styleType="body300" content={license_number}>
                {license_number}
              </Type>
              // <p
              //   className="profile-Tiltle-sub"
              //   content={license_number}
              //   style={{ margin: "0 0 5px" }}>
              //   {license_number}
              // </p>
            )}
            {advertiser_id && agentdetail && (
              <Type styleType="body300" content={officeName}>
                {officeName}
              </Type>
            )}
            {advertiser_id ? (
              <Type as="div" styleType="body300">
                <div
                  className={
                    reviewData &&
                    reviewData.length > 0 &&
                    recommendationData &&
                    recommendationData.length > 0
                      ? "stickyspace pt-3"
                      : "stickyspace column-flex pt-3"
                  }>
                  <div className="rating-section">
                    {canShowRating ? (
                      <span className="ratings">
                        {reviewData && reviewData.length > 0 ? (
                          <span>
                            {" "}
                            <span className="review-star">
                              <IconStar
                                color={rdcUiTheme.color.interactive.primary.default.initial}
                              />
                            </span>
                            <span
                              className="track-my-clicks"
                              data-linkname={OMNITURE_LINK_NAME.ADP.TRAVERSE_REVIEW}
                              onClick={(e) => {
                                clickDetectorAndScroll({ type: "rev", clicked: true });
                                this.trackOmnitureClick(e);
                              }}
                              id="rev">
                              {" "}
                              <span className="review"> {agent_rating} </span>
                              <span className="gray-font">
                                ({reviewData && reviewData.length})
                              </span>{" "}
                            </span>
                            <span className="separator-dot">.</span>
                          </span>
                        ) : isDotRealtor ? (
                          <Popover
                            header={
                              <span as="span" bold>
                                To write a review click{" "}
                                <a
                                  target="_blank"
                                  and
                                  rel="noopener noreferrer"
                                  href={dotRealtorWebUrl}>
                                  here
                                </a>
                              </span>
                            }
                            open={this.state.showDotRealtorRedirectLink}
                            onClose={this.handleDotRealtorRedirectClose}
                            placement="bottom-start"
                            detachPopover="sm"
                            customWidths={customWidths}>
                            <span
                              className="empty-content-text set-review-modal-track-data"
                              id="empty_state_top_review"
                              onClick={this.showReviewModal}>
                              {" "}
                              <a href="#" className="preview-link">
                                {" "}
                                Write {agentdetail && agentdetail.team ? fullName : personName}
                                &apos;s 1st review
                              </a>
                            </span>
                          </Popover>
                        ) : (
                          <span
                            className="empty-content-text set-review-modal-track-data"
                            id="empty_state_top_review"
                            onClick={this.showReviewModal}>
                            {" "}
                            <a href="#" className="preview-link">
                              Write {agentdetail && agentdetail.team ? fullName : personName}&apos;s
                              1st review
                            </a>
                          </span>
                        )}
                      </span>
                    ) : null}

                    {recommendationData && recommendationData.length > 0 ? (
                      <>
                        <span
                          className="ratings track-my-clicks"
                          data-linkname={OMNITURE_LINK_NAME.ADP.TRAVERSE_RECOMM}
                          id="rec"
                          onClick={(e) => {
                            clickDetectorAndScroll({ type: "rec", clicked: true });
                            this.trackOmnitureClick(e);
                          }}>
                          <span className="review-recommendations">
                            <IconComment className="pr-1" />
                          </span>
                          <span className="review pr-2">
                            {recommendationData && recommendationData.length}
                          </span>{" "}
                          <span className="gray-font">
                            {lang && lang.ldp_content && lang.ldp_content.recommendations_lower}
                          </span>
                        </span>
                      </>
                    ) : (
                      <span className="empty-content-text" onClick={this.showRecommendationModal}>
                        {" "}
                        <a href="#" className="preview-link">
                          Write {agentdetail && agentdetail.team ? fullName : personName}&apos;s 1st
                          recommendation
                        </a>
                      </span>
                    )}
                  </div>
                </div>
              </Type>
            ) : null}
            {/* {this.props.isMonetizationProfile && <SendMessageButton {...this.props} />} */}
          </div>
        </div>
      </>
    );
  }
}

ProfilePicSection.defaultProps = {};

ProfilePicSection.propTypes = {
  agentdetail: PropTypes.object,
  reviewData: PropTypes.array,
  recommendationData: PropTypes.array,
  lang: PropTypes.object,
  showRecommendationModal: PropTypes.func,
  showReviewModal: PropTypes.func,
  clickDetectorAndScroll: PropTypes.func,
  query: PropTypes.object,
  agentData: PropTypes.object,
  web_url: PropTypes.string,
  id: PropTypes.string,
  askAQuestion: PropTypes.func,
  loginData: PropTypes.object,
  isUserLoggedIn: PropTypes.bool,
  ask_a_question_modal: PropTypes.func,
  isMonetizationProfile: PropTypes.bool,
};
